import ResidentStatusHistoryTemplate from "app/features/residents/templates/view/ResidentStatusHistoryTemplate";

export default function ResidentStatusHistoryScreen() {
  return <ResidentStatusHistoryTemplate />;
}
